import { render, staticRenderFns } from "./PaxOnPlaceList.vue?vue&type=template&id=7a8cb518&scoped=true"
import script from "./PaxOnPlaceList.vue?vue&type=script&lang=js"
export * from "./PaxOnPlaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8cb518",
  null
  
)

export default component.exports